import { useTranslation } from "react-multi-lang";
import { useDispatch, useSelector } from "react-redux";
import Action from "../redux/Action";

const SelectDiscountAppliesTo = () => {
  const t = useTranslation();
  const dispatch = useDispatch();

  const formValue = useSelector((state) => state.reducer.formValue);
  const errors = useSelector((state) => state.reducer.errors);

  const getOptions = () => {
    if (
      formValue.promoCharge === "SHIPPER" ||
      formValue.promoCharge === "ADMIN_AND_SHIPPER"
    ) {
      return [{ value: "SHIPPING_FEE", label: "Shipping Fee" }];
    }

    return [
      { value: "ITEM_PRICE", label: "Item Price" },
      { value: "ADMIN_FEE", label: "Admin Fee" },
      { value: "SHIPPING_FEE", label: "Shipping Fee" },
      { value: "TOTAL_ORDER_PRICE", label: "Total Order Price" },
    ];
  };

  const options = getOptions();

  return (
    <select
      className={`text-sm border ${errors.discountAppliesTo ? "border-red-500" : "border-gray-primary"} rounded-xl w-full bg-white font-medium `}
      name="discountAppliesTo"
      value={formValue.discountAppliesTo}
      onChange={(e) => {
        const name = e.target.name;
        const value = e.target.value;
        Action.handleFormChange(dispatch, { name, value, formValue });
      }}
    >
      <option value="" disabled>
        {t("management.select_target")}
      </option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default SelectDiscountAppliesTo;
